import { toPng } from 'html-to-image';

/**
 * Baixa um elemento HTML como imagem PNG.
 * @param elementRef - Ref do elemento HTML (ex: useRef.current)
 * @param fileName - Nome do arquivo para download
 * @returns Promise<void>
 */
export async function downloadElementAsPng(
  elementRef: HTMLElement | null,
  fileName: string,
) {
  if (!elementRef) return;

  const dataUrl = await toPng(elementRef, {
    skipFonts: true,
    quality: 1,
    pixelRatio: 2,
    backgroundColor: '#ffffff',
  });
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = fileName;
  link.click();
}
